module.exports = __webpack_public_path__ + "asset/image/utility-off-54a1.svg";